import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Eye, X, Shield } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ImpersonationBanner() {
  const navigate = useNavigate();
  const [session, setSession] = useState(null);

  useEffect(() => {
    const stored = localStorage.getItem('impersonation_session');
    if (stored) {
      try { setSession(JSON.parse(stored)); } catch { }
    }
  }, []);

  const endImpersonation = async () => {
    if (!session) return;
    try {
      await axios.post(`${API}/saas/impersonate/${session.session_id}/end`);
    } catch { }
    localStorage.removeItem('impersonation_session');
    localStorage.removeItem('tenant_id');
    localStorage.removeItem('auth_token');
    localStorage.removeItem('auth_user');
    setSession(null);
    navigate('/admin/saas/tenants');
  };

  if (!session) return null;

  return (
    <div className="impersonation-banner" data-testid="impersonation-banner">
      <Eye size={18} />
      <span className="imp-label">Impersonating:</span>
      <strong>{session.tenant_name}</strong>
      <span className="imp-role"><Shield size={14} /> Tenant Admin</span>
      <button className="end-btn" onClick={endImpersonation} data-testid="end-impersonation-btn">
        <X size={14} /> End Impersonation
      </button>
    </div>
  );
}
